interface BrushOpacityControlProps {
  value: number;
  disabled?: boolean;
  onChange: (opacity: number) => void;
}

export function BrushOpacityControl({
  value,
  disabled = false,
  onChange,
}: BrushOpacityControlProps) {
  const percentage = Math.round(value * 100);
  return (
    <label className="drawing-control" htmlFor="brush-opacity">
      <span>
        Opacity <output htmlFor="brush-opacity">{percentage}%</output>
      </span>
      <input
        disabled={disabled}
        id="brush-opacity"
        max="100"
        min="10"
        onChange={(event) => onChange(Number(event.target.value) / 100)}
        step="5"
        type="range"
        value={percentage}
      />
    </label>
  );
}
